import { bold, Summary } from './primitives';
import type { SummarySlice } from './types';

export const attachmentSummaries = {
  'attachment.renamed': ({ entry }) => (
    <Summary>
      {bold(entry.from)}&nbsp;attachment renamed to&nbsp;{bold(entry.to)}
    </Summary>
  ),
} satisfies SummarySlice;
